import { render, staticRenderFns } from "./SkillsTable.vue?vue&type=template&id=5f4c2c1e&scoped=true&"
import script from "./SkillsTable.vue?vue&type=script&lang=js&"
export * from "./SkillsTable.vue?vue&type=script&lang=js&"
import style0 from "./SkillsTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SkillsTable.vue?vue&type=style&index=1&id=5f4c2c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4c2c1e",
  null
  
)

export default component.exports